import React from 'react';
import styled from 'styled-components';
import ProductImage from '@prisjakt/ui-product-image';
import {
  BodySmallText,
  CaptionText,
  FontEmphasis,
} from '@prisjakt/ui/text/variants';
import { Column } from '@prisjakt/ui/list/variants';
import Currency from '@prisjakt/ui-currency';
import { HighlightedName } from '../highlighted-name';
import { ListItem, ListItemButton, NameLabel, Labels, Wrapper } from './styles';
import { layout } from '@prisjakt/ui-base';
import { useAppContext } from '@prisjakt/ui-app-context';
import { BaseItemProps } from './types';
import { PriceText } from 'src/components/offer/price/price-text';

type Props = BaseItemProps & {
  price?: number | null;
  category?: string | null;
};

export const ProductItem = (props: Props) => {
  const { id, text, price, order, selected, onClick, query, category } = props;
  const { market = { cdn: 'https://cdn.pji.nu' }, t } = useAppContext();

  const imageSrc = `${market.cdn}/product/standard/80/${id}.jpg`;

  return (
    <ListItem data-test="ProductItem" order={order} $selected={selected}>
      <Button onClick={onClick}>
        <Wrapper>
          <Image src={imageSrc} />

          <Labels>
            <Column>
              <NameLabel containerProps={{ 'data-test': 'NameLabel' }}>
                <HighlightedName query={query}>{text}</HighlightedName>
              </NameLabel>
              {category && <CaptionText>{category}</CaptionText>}
            </Column>
          </Labels>
        </Wrapper>

        {price ? (
          <Labels gap={0.25}>
            <BodySmallText emphasis={FontEmphasis.LOW}>
              {t('product', 'price.from-abbr')}
            </BodySmallText>
            <PriceText>
              <Currency price={price} />
            </PriceText>
          </Labels>
        ) : null}
      </Button>
    </ListItem>
  );
};

const Button = styled(ListItemButton)`
  && {
    height: auto;
    padding-top: ${layout.measurements.spacing025};
    padding-bottom: ${layout.measurements.spacing025};
  }
`;

const Image = styled(ProductImage)`
  height: 48px;
`;
